<template>
  <div class="evaluate-list">
    <div class="evaluate-item general-box-shadow" v-for="evaluate in customerEvaluateList">
      <img v-if="evaluate.customerAvatar" :src="evaluate.customerAvatar">
      <img v-if="!evaluate.customerAvatar" src="../../../assets/icon/icon-defualt-avatar.png">
      <div class="evaluate-info">
        <div class="name">{{evaluate.customerName}}</div>
        <div class="date">{{evaluate.projectName}}&nbsp;&nbsp;&nbsp;&nbsp;{{evaluate.createTime | simpleDayFilter}}</div>
        <div class="content" style="font-size: 0.29rem;line-height: 0.35rem;margin-top: 0.1rem">{{evaluate.content}}</div>
      </div>
      <div class="evaluate-score">
        <div class="score">{{evaluate.score | score}}</div>
        评分
      </div>
    </div>
    <div v-if="customerEvaluateList.length == 0" class="black-page">
      <img src="../../../assets/icon-no-img.png">
      <div class="tip">该公司暂无的相关评价信息!</div>
    </div>
  </div>
</template>
<script>
  import {imgUrl} from '../../../config'
  import {Toast} from "mint-ui";
  import EvaluateService from "../../../service/customer/EvaluateService";

  export default {
    name: 'CompanyEvaluateList',
    props:['companyId'],
    data () {
      return {
        customerEvaluateList:[],
      }
    },
    created () {
      this.getEvaluateList()
    },
    methods: {
      async getEvaluateList(){
        var result = await EvaluateService.evaluateList('',this.companyId,'','');
        if(result.code == 0){
          this.customerEvaluateList = result.data;
          for (let evaluate of this.customerEvaluateList) {
            evaluate.customerName = evaluate.onestopProject.customerName;
            if(evaluate.customerUser != null){
              evaluate.customerAvatar = evaluate.customerUser.avatarUrl;
            }else if(evaluate.customerAvatar){
              evaluate.customerAvatar = imgUrl + evaluate.customerAvatar;
            }
            let projectName = evaluate.onestopProject.name;
            if(projectName && projectName.length > 17){
              projectName = projectName.substring(0,14) + '...';
            }
            this.$set(evaluate,'projectName',projectName);
          }
        }else {
          Toast('获取评价信息失败');
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .evaluate-list{
    width: 6.9rem;
    margin: 0 auto;
    .evaluate-item{
      position: relative;
      display: flex;
      margin-bottom: 0.2rem;
      img{
        width: 0.88rem;
        height: 0.88rem;
        border-radius: 0.88rem;
        margin: 0.2rem;
      }
      .evaluate-info{
        width: 5.4rem;
        text-align: justify;
        margin-top: 0.3rem;
        font-size: 0.28rem;
        color: #191818;
        .date{
          font-size: 0.24rem;
          font-weight: normal;
          color: #7f7d7c;
        }
        .content{
          margin-top: 0.07rem;
          padding-bottom: 0.3rem;
          font-size: 0.3rem;
          line-height: 0.3rem;
        }
        .icon-evaluate-edit-btn{
          width: 0.23rem;
          height: 0.23rem;
          margin: 0;
        }
      }
      .evaluate-score{
        position: absolute;
        right: 0.21rem;
        background: url("../../../assets/icon-evaluate-bg.png") no-repeat;
        width: 0.58rem;
        height: 0.8rem;
        line-height: 0.25rem;
        background-size: 100%;
        font-size: 0.18rem;
        color: white;
        text-align: center;
        .score{
          margin-top: 0.05rem;
          font-size: 0.24rem;
          font-weight: bold;
        }
      }
    }
  }
</style>

